import React from 'react'
import PropTypes from 'prop-types'

import { Hide } from '../../components/Hide'

import './RCDescription.css'

const RCDescription = ({ split = false, html = { __html: '' }, dark = false }) => {
    const className = split ? 'split' : ''
    const fontColor = dark ? 'dark' : ''

    return (
        <Hide ifEmpty={html.__html}>
            <div
                className={`rc-description rc-description--${className} rc-description--${fontColor}`}
                dangerouslySetInnerHTML={html}
            />
        </Hide>
    )
}

RCDescription.propTypes = {
    split: PropTypes.bool,
    html: PropTypes.shape({
        __html: PropTypes.string
    }),
    dark: PropTypes.bool
}

export { RCDescription }
